import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddEbook, IEbook } from "../../Ebook.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useEditEbook = (ebookId: string, setSelectedEbookId: any) => {

  const form = new FormData();
  const [formData, setFormData] = useState<IAddEbook>({
    languageName: "",
    courseName: "",
    standard: "",
    subject: "",
    bookName: "",
    eBookPrice: 0,
    isPhysicalBookAvailable: "NA",
    physicalBookPrice: 0,
    description: "",
    availability: true,
    imageUrl: null,
    pdfUrl: null,
    subjectName:""
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const [subjectName, setSubjectName] = useState<any[]>([]);
  const isPhyiscalBookAvailable = [
    { isPhysicalBookAvailable: "Available" },
    { isPhysicalBookAvailable: "NA" },
  ];
  const [standard, setStandard] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getbook}/${ebookId}`,
      });
      console.log("Fetched Ebook Data:", response);
      populateFormData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (ebookData: IEbook) => {
    setFormData({
      languageName: ebookData.languageName,
      courseName: ebookData.courseName || "",
      standard: ebookData.standard,
      subject: ebookData.subjectName || '',
      bookName: ebookData.bookName,
      eBookPrice: ebookData.eBookPrice || 0,
      isPhysicalBookAvailable: ebookData.isPhysicalBookAvailable,
      physicalBookPrice: ebookData.physicalBookPrice || 0,
      description: ebookData.description,
      imageUrl: ebookData.imageUrl,
      pdfUrl: ebookData.pdfUrl,
      availability: ebookData.availability,
    }); 
  };



    const handleChange = (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >
    ) => {
      const { id, value } = e.target;
      const files = (e.target as HTMLInputElement).files;
    
      if (id === "imageUrl" || id === "pdfUrl") {
        setFormData((prevState) => ({
          ...prevState,
          [id]: files ? files[0] : null,
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [id]: value,
        }));
      }
    };
  

  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [
        coursesResponse,
        languagesResponse,
        subjectResponse,
        standardResponse,
      ] = await Promise.all([
        ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
        ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
        ApiService({ method: "GET", endpoint: apiPaths.getSubject }),
        ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
      ]);
      setCourses(coursesResponse);
      setLanguages(languagesResponse);
      setSubjectName(subjectResponse);
      setStandard(standardResponse);
      if (!coursesResponse.length || !languagesResponse.length) {
        toast.error("No data found for courses or languages.");
      }
    } catch (error) {
      console.error("Error fetching courses and languages:", error);
      toast.error("Failed to fetch courses or languages.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit: SubmitHandler<IAddEbook> = async () => {
    setLoading(true);
  
  
    const formDataToSend = new FormData();

    // Append the non-file fields
       formDataToSend.append("languageName", formData.languageName);
      formDataToSend.append("courseName", formData.courseName);
      formDataToSend.append("standard", formData.standard);
      formDataToSend.append("subjectName", formData.subject);
      formDataToSend.append("bookName", formData.bookName);
      formDataToSend.append("eBookPrice", String(formData.eBookPrice));
      formDataToSend.append("isPhysicalBookAvailable", formData.isPhysicalBookAvailable);
      formDataToSend.append("physicalBookPrice", String(formData.physicalBookPrice));
      formDataToSend.append("description", formData.description);
      formDataToSend.append("availability", formData.availability.toString());

      // Attach files if present
      if (formData.imageUrl) {
        formDataToSend.append("imageUrl", formData.imageUrl);
      }
      if (formData.pdfUrl) {
        formDataToSend.append("pdfUrl", formData.pdfUrl);
      }

    


   
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updatebook}/${ebookId}`,
        data: formDataToSend, // Send FormData to backend
        headers: {
          "Content-Type": "multipart/form-data", // This is important for file uploads
        },
      });
  
      toast.success("Ebook updated successfully!");
      setSelectedEbookId(null);
      window.location.reload();
    } catch (error) {
      console.error("Error updating ebook:", error);
      toast.error("Failed to update ebook.");
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchCoursesAndLanguages();
    fetchData();
  }, [ebookId]);

  const handleCancel = () => {
    setSelectedEbookId(null);
  };

  return {
    formData,
    setFormData,
    loading,
    languages,
    courses,
    subjectName,
    standard,
    isPhyiscalBookAvailable,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useEditEbook;
